<article>
  <div *ngIf="!iscustom" class="pending">
    <nb-icon icon="alert-triangle-outline"></nb-icon><span>{{ 'companymanaged' | translate }}</span>
  </div>
  <form *ngIf="form && !isLoading" [formGroup]="form">
    <h1>{{ (experience.type === ExperienceType.School ? 'schooldetails' : 'companydetails') | translate }}</h1>
    <div class="input-group">
<!--      <bst-photo-uploader [disabled]="!this.iscustom" [size]="80" shape="semi-round"></bst-photo-uploader>-->
      <ul *ngIf="!isSchool" class="field-list">
        <li>
          <label><nb-icon icon="briefcase-outline"></nb-icon><span>{{ 'company' | translate }}</span></label>
          <input nbInput fieldSize="medium" [maxlength]="100" [placeholder]="'enteritem' | translate:{value: ('company' | translate)}" formControlName="name">
        </li>
        <li>
          <label><nb-icon icon="shield-outline"></nb-icon><span>{{ 'companyrole' | translate }}</span></label>
          <input nbInput fieldSize="medium" [maxlength]="100" [placeholder]="'enteritem' | translate:{value: ('companyrole' | translate)}" formControlName="position">
        </li>
        <li>
          <label><nb-icon icon="compass-outline"></nb-icon><span>{{ 'location' | translate }}</span></label>
          <bst-places-editor size="medium" [maxlength]="255" [placeholder]="'enteritem' | translate:{value: ('location' | translate)}" formControlName="location"></bst-places-editor>
        </li>
        <li>
          <label><nb-icon icon="calendar-outline"></nb-icon><span>{{ 'startdate' | translate }}</span></label>
          <ng-container>
            <input nbInput [placeholder]="'enterstartdate' | translate" fieldSize="medium" [nbDatepicker]="datepickerstart" formControlName="start">
            <nb-datepicker #datepickerstart></nb-datepicker>
          </ng-container>
        </li>
        <li>
          <label><nb-icon icon="calendar-outline"></nb-icon><span>{{ 'enddate' | translate }}</span></label>
          <div>
            <div *ngIf="isCustom(form) || !form.get('end').value">
              <nb-checkbox formControlName="ongoing" (checkedChange)="form.get('end').setValue(null)">{{ 'ongoing' | translate }}</nb-checkbox>
            </div>
            <ng-container *ngIf="!form.get('ongoing').value">
              <input nbInput [placeholder]="'enterenddate' | translate" fieldSize="medium" [nbDatepicker]="datepickerend" formControlName="end">
              <nb-datepicker #datepickerend></nb-datepicker>
            </ng-container>
          </div>
        </li>
      </ul>
      <ul *ngIf="isSchool" class="field-list">
        <li>
          <label><nb-icon icon="home-outline"></nb-icon><span>{{ 'school' | translate }}</span></label>
          <bst-list-adder size="medium" [target]="'school'" [maxlength]="100" [single]="true" [placeholder]="'enteritem' | translate:{value: 'school' | translate}" [saveunknown]="true" formControlName="name"></bst-list-adder>
        </li>
        <li>
          <label><nb-icon icon="shield-outline"></nb-icon><span>{{ 'degree' | translate }}</span></label>
          <nb-select size="medium" formControlName="degree">
            <nb-option [value]="DegreeType.Associate">{{ 'degrees.1' | translate }}</nb-option>
            <nb-option [value]="DegreeType.Bachelor">{{ 'degrees.2' | translate }}</nb-option>
            <nb-option [value]="DegreeType.Master">{{ 'degrees.3' | translate }}</nb-option>
            <nb-option [value]="DegreeType.Doctor">{{ 'degrees.4' | translate }}</nb-option>
          </nb-select>
        </li>
        <li>
          <label><nb-icon icon="color-palette-outline"></nb-icon><span>{{ 'degreemajor' | translate }}</span></label>
          <input nbInput fieldSize="medium" [maxlength]="100" [placeholder]="'enteritem' | translate:{value: ('degreemajor' | translate)}" formControlName="degree_major">
        </li>
        <li>
          <label><nb-icon icon="calendar-outline"></nb-icon><span>{{ 'startdate' | translate }}</span></label>
          <ng-container>
            <input nbInput [placeholder]="'enterstartdate' | translate" fieldSize="medium" [nbDatepicker]="datepickerstart" formControlName="start">
            <nb-datepicker #datepickerstart></nb-datepicker>
          </ng-container>
        </li>
        <li>
          <label><nb-icon icon="calendar-outline"></nb-icon><span>{{ 'enddate' | translate }}</span></label>
          <div>
            <div *ngIf="isCustom(form) || !form.get('end').value">
              <nb-checkbox formControlName="ongoing" (checkedChange)="form.get('end').setValue(null)">{{ 'ongoing' | translate }}</nb-checkbox>
            </div>
            <ng-container *ngIf="!form.get('ongoing').value">
              <input nbInput [placeholder]="'enterenddate' | translate" fieldSize="medium" [nbDatepicker]="datepickerend" formControlName="end">
              <nb-datepicker #datepickerend></nb-datepicker>
            </ng-container>
          </div>
        </li>
        <li *ngIf="!form.get('ongoing').value">
          <label><nb-icon icon="checkmark-outline"></nb-icon><span>{{ 'completeddegree' | translate }}</span></label>
          <nb-radio-group formControlName="degree_finished">
            <nb-radio [value]="1">{{ 'yes' | translate }}</nb-radio>
            <nb-radio [value]="0">{{ 'nee' | translate }}</nb-radio>
          </nb-radio-group>
        </li>
      </ul>
      <div>
        <label><nb-icon icon="info-outline"></nb-icon><span>{{ 'description' | translate }}</span></label>
        <textarea nbInput fullWidth fieldSize="medium" [maxlength]="2000" [placeholder]="'enteritem' | translate:{value: ('description' | translate)}" formControlName="description"></textarea>
      </div>
      <div>
        <label><nb-icon icon="star-outline"></nb-icon><span>{{ (isSchool ? 'achievements' : 'achievements/responsibilties') | translate }}</span></label>
        <bst-list-adder [placeholder]="'enterandenter' | translate" [fullWidth]="true" size="medium" [maxlength]="500" [vertical]="true" [saveunknown]="true" formControlName="items"></bst-list-adder>
      </div>
    </div>
    <div *ngIf="!isSchool" class="projects">
      <bst-table-editor [autoopen]="opento" (onEdit)="markRes($event)" (onAdd)="$event.type = ExperienceType.CustomProject; markRes($event)" [couldEditItem]="this.couldEdit" [couldDeleteRow]="this.couldDelete" [title]="'companyprojects' | translate" [subtitle]="'project' | translate" [standardColumns]="projectdefs" formControlName="projects"></bst-table-editor>
      <bst-table-editor [autoopen]="opento" (onEdit)="markRes($event)" (onAdd)="$event.type = ExperienceType.CustomPosition; markRes($event)" [couldEditItem]="this.couldEdit" [couldDeleteRow]="this.couldDelete" [title]="'companyroles' | translate" [subtitle]="'position' | translate" [standardColumns]="roledefs" formControlName="roles"></bst-table-editor>
    </div>
  </form>
</article>

<ng-template #enddate let-col="col" let-row="row" let-editable="editable" let-form="form" let-fields="fields">
  <div *ngIf="form; else nf">
    <nb-checkbox #checkbox [checked]="!fields.get('end').value" [disabled]="!editable" (checkedChange)="fields.get('end').setValue(null)">{{ 'ongoing' | translate }}</nb-checkbox>
    <div *ngIf="!checkbox.checked">
      <input nbInput [placeholder]="'enterdate' | translate" fieldSize="medium" [nbDatepicker]="datepickerend" [formControl]="form">
      <nb-datepicker #datepickerend></nb-datepicker>
    </div>
  </div>
  <ng-template #nf>
    {{ row[col.name] ? (row[col.name] | dateify | date:'longDate') : ('ongoing' | translate) }}
  </ng-template>
</ng-template>

<ng-template #responsibilities let-col="col" let-row="row" let-editable="editable" let-form="form" let-fields="fields">
  <div *ngIf="form; else nf">
    <bst-list-adder [placeholder]="'enterandenter' | translate" [fullWidth]="true" size="medium" [maxlength]="500" [vertical]="true" [saveunknown]="true" [formControl]="form"></bst-list-adder>
  </div>
  <ng-template #nf>
    {{ row[col.name] ? row[col.name].length : 0 }}
  </ng-template>
</ng-template>
